export { default } from "./Welcome";
